import { Filter } from "@/shared/lib/filter/filter";
import { DocumentId, DocumentKind, SubdomainName } from "@bitory-gmbh/bsm";
import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";

export type OutboxBase = {
  outboxId: string;
  outboxStatus: OutboxStatus;
  outboxCreatedAt: RFC3339timestamp;
  outboxUpdatedAt: RFC3339timestamp;
};

export enum OutboxStatus {
  InProgress = "in_progress",
  Sent = "sent",
}

export type OutboxAuthorizationReference = {
  outboxCompanyId: UUID;
  outboxBranchIds: UUID[];
};

export type OutboxCustomerReference = {
  outboxCustomerId: UUID;
  outboxServiceObjectIds: UUID[];
};

export type OutboxDocumentReference = {
  outboxDocumentSubdomain: SubdomainName;
  outboxDocumentKind: DocumentKind;
  outboxDocumentId: UUID;
  outboxDocumentNumber: string;
};

export type OutboxBaseFilters = {
  outboxStatus?: Filter<OutboxStatus>;
  outboxCreatedAt?: Filter<RFC3339timestamp>;
  outboxUpdatedAt?: Filter<RFC3339timestamp>;
};

export type OutboxAuthorizationReferenceFilters = {
  outboxCompany?: Filter<string>;
  outboxBranch?: Filter<string>;
};

export type OutboxCustomerReferenceFilters = {
  outboxCustomer?: Filter<string>;
  outboxServiceObject?: Filter<string>;
};

export type OutboxDocumentReferenceFilters = {
  outboxDocumentSubdomain?: Filter<SubdomainName>;
  outboxDocumentKind?: Filter<DocumentKind>;
  outboxDocumentId?: Filter<DocumentId>;
  outboxDocumentNumber?: Filter<string>;
};
